<maplix-ui-preloader [display]="true"></maplix-ui-preloader>
